module.exports = "/assets/ec4d3554b9ae85c8a77712235051c232.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/D6.png
// module id = 1290
// module chunks = 0